<script>
import axios from 'axios';
import {RAW_MATERIAL_PATH} from '@/path';
import Swal from 'sweetalert2';

    export default {
        props : ['selectedRawMaterial'],
        data(){
            return {
                data : {
                    raw_material_id : this.selectedRawMaterial.id
                },
                base_url : process.env.VUE_APP_API_BACKEND_URL
            }
        },
        methods : {
            async save(){
                try {
                    let res = await axios.post(this.base_url + RAW_MATERIAL_PATH.ADD_PRICE,this.data);
                    if(res.data.status){
                        Swal.fire("Saved Successfully","","success");
                        this.$emit('reload');
                        return;
                    }
                    throw new Error("Failed to save");
                } catch (error) {
                    console.log(error);
                    Swal.fire("Failed to save","","error");
                }
            }            
        }
    }
</script>

<template>
    <b-row>
        <b-col sm="12">
            <label>Raw Material</label>
            <p>{{ selectedRawMaterial.title }}</p>
        </b-col>
        <b-col sm="12">
            <label>Unit Price</label>
            <b-input v-model="data.unit_price"></b-input>
        </b-col>
        <b-col sm="12">
            <label>Uom</label>
            <b-select :options="['kg','gm','pcs','ltr']" v-model="data.uom"></b-select>
        </b-col>
        <b-col sm="12">
            <b-button class="mt-5" variant="success" @click="save">Save</b-button>
        </b-col>        
    </b-row>
</template>

<style>
    
</style>